"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddValueContainer = void 0;
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const attributes_1 = require("../../../client/attributes");
const global_tree_edit_warning_1 = require("../../../components/global-tree-edit-warning");
const context_1 = require("../../../context");
const generic_1 = require("../../../generic");
const add_some_values_button_1 = require("../../../generic/create-entity-dialog/create-entity-form/partials/add-some-values-button");
const use_attribute_values_dialog_state_hook_1 = require("../../../hooks/use-attribute-values-dialog-state.hook");
const add_value_dialog_utils_1 = require("../../../preview-products-widget/strategy-attributes/attribute-action-dialogs/add-value-dialog.utils");
const validation_schema_1 = require("../../../preview-products-widget/strategy-attributes/attribute-action-dialogs/validation-schema");
const use_strategy_matrix_query_params_sync_1 = require("../../hooks/use-strategy-matrix-query-params-sync");
const hooks_1 = require("../../../../hooks");
const localization_1 = require("../../../../localization");
const localization_utils_1 = require("../../../../localization/localization.utils");
const router_constants_1 = require("../../../../router/router.constants");
const store_1 = require("../../../../store");
const CREATE_VALUE_FORM_ID = 'create-value-form';
const AddValueContainer = ({ selectedAttribute: defaultSelectedAttributeName, selectedStrategyNodeId, allowCreation, onClose, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { addSuccess, addError } = (0, hooks_1.useNotification)();
    const { isReEnrichmentInProgress } = (0, context_1.useCatalogActivityProgressContext)();
    const productTreeRootNodeId = (0, store_1.useProductTreeRootNodeId)();
    const catalogId = (0, store_1.useSelectedCatalogId)();
    const projectId = (0, store_1.useSelectedProjectId)();
    const shouldShowGlobalTreeEditWarning = (0, store_1.useShouldShowGlobalTreeEditWarning)();
    const validationSchema = (0, validation_schema_1.useAttributeValidationSchema)();
    const navigate = (0, react_router_1.useNavigate)();
    const { onGlobalTreeReplacement } = (0, global_tree_edit_warning_1.useGlobalTreeEditWarning)(selectedStrategyNodeId);
    const { editAttributes } = (0, attributes_1.useEditAttributes)();
    const { selectedAttributeName, setSelectedAttributeName, dialogInitialValues, dialogLoading, attributesOptionList, matchedValueNames, loadedValueItems, valuesLoading, valuesHasNextPage, valuesMoreItemsLoading, handleValuesLoadMore, handleValueSearch, } = (0, use_attribute_values_dialog_state_hook_1.useAttributeValuesDialogState)({
        defaultSelectedAttributeName,
        selectedStrategyNodeId,
        catalogId,
    });
    const dispatchError = (attributes, error) => {
        addError(t({
            key: 'ADD_ENTITY_ERROR',
            values: {
                count: attributes.length,
                entity: String(t({ key: 'VALUE' })).toLowerCase(),
                b: localization_utils_1.renderBoldText,
            },
        }), error);
    };
    const handleTreeReplacement = (isGlobalStrategyReplacementAccepted) => __awaiter(void 0, void 0, void 0, function* () {
        const isTreeReplacementNeeded = shouldShowGlobalTreeEditWarning && isGlobalStrategyReplacementAccepted;
        if (!isTreeReplacementNeeded) {
            return { rootNodeId: productTreeRootNodeId, targetNodeId: selectedStrategyNodeId };
        }
        const metadata = yield onGlobalTreeReplacement();
        if (!metadata.targetNodeId) {
            throw new Error('Target node is not found');
        }
        return metadata;
    });
    const handleAddValuesToSelectedNode = (formValues) => __awaiter(void 0, void 0, void 0, function* () {
        const parsedAttributeData = (0, add_value_dialog_utils_1.parseFormValues)(formValues.attributes[0]);
        const { valuesWithNewGuideline = [], isDescriptionChanged, newValues = [] } = parsedAttributeData, attribute = __rest(parsedAttributeData, ["valuesWithNewGuideline", "isDescriptionChanged", "newValues"]);
        try {
            const { rootNodeId, targetNodeId } = yield handleTreeReplacement(formValues.isGlobalStrategyReplacementAccepted);
            const promises = [];
            if ((valuesWithNewGuideline === null || valuesWithNewGuideline === void 0 ? void 0 : valuesWithNewGuideline.length) || isDescriptionChanged) {
                promises.push(editAttributes([Object.assign(Object.assign({}, attribute), { values: valuesWithNewGuideline })], [rootNodeId]));
            }
            const responses = yield Promise.allSettled(promises);
            for (const response of responses) {
                if (response.status === 'rejected') {
                    throw new Error(response.reason);
                }
            }
            addSuccess(t({ key: 'EDIT_GUIDELINES_SUCCESS', values: { entityName: attribute.name } }));
            if (targetNodeId && rootNodeId !== targetNodeId) {
                const serializedSearchParams = (0, use_strategy_matrix_query_params_sync_1.getStrategyMatrixSearchParamsString)({
                    projectId,
                    catalogId,
                    viewState: Object.assign({ [use_strategy_matrix_query_params_sync_1.StrategyMatrixViewQueryStateField.TerminalNodeId]: targetNodeId }, (selectedAttributeName ? { [use_strategy_matrix_query_params_sync_1.StrategyMatrixViewQueryStateField.SelectedAttributes]: [selectedAttributeName] } : {})),
                });
                navigate(`${router_constants_1.STRATEGY_MATRIX_PATH}${serializedSearchParams}`, { relative: 'path', replace: true });
            }
            else {
                const serializedSearchParams = (0, use_strategy_matrix_query_params_sync_1.getStrategyMatrixSearchParamsString)({ projectId, catalogId });
                navigate(`${router_constants_1.STRATEGY_MATRIX_PATH}${serializedSearchParams}`, { relative: 'path', replace: true });
            }
        }
        catch (error) {
            dispatchError(formValues.attributes, error.message);
        }
        finally {
            onClose();
        }
    });
    return (react_1.default.createElement(generic_1.CreateEntityDialog, { allowCreation: allowCreation, isReadOnly: isReEnrichmentInProgress, initialValues: dialogInitialValues, validationSchema: validationSchema, title: allowCreation
            ? (() => {
                const titleText = t({
                    key: 'ADD_ENTITY_TO_ENTITY',
                    values: {
                        entity: String(t({ key: 'VALUES' })).toLowerCase(),
                        targetEntity: String(t({ key: 'ATTRIBUTE' })).toLowerCase(),
                    },
                });
                return (react_1.default.createElement("div", { className: "create-entity-dialog-title" }, react_1.default.createElement("div", { className: "create-entity-dialog-title-text" }, titleText), !selectedAttributeName && !isReEnrichmentInProgress && (react_1.default.createElement(add_some_values_button_1.AddSomeValuesButton, { className: "create-entity-dialog-title-action", title: t({ key: 'ADD_ENTITY', values: { entity: t({ key: 'ATTRIBUTE' }) } }), buttonVariant: "outlined", iconVariant: "plus", singleSelect: true, options: attributesOptionList, onSelect: (selected) => setSelectedAttributeName(selected[0]), onCreate: (created) => setSelectedAttributeName(created[0]) }))));
            })()
            : t({ key: 'GUIDELINE_DIALOG_TITLE' }), formId: CREATE_VALUE_FORM_ID, attributesOptionList: attributesOptionList, isLoading: dialogLoading, valueOptionListStrategyNodeId: productTreeRootNodeId, selectedStrategyNodeId: selectedStrategyNodeId, matchedValueNames: matchedValueNames, loadedValueItems: loadedValueItems, valuesLoading: valuesLoading, valuesHasNextPage: valuesHasNextPage, valuesMoreItemsLoading: valuesMoreItemsLoading, onValuesLoadMore: handleValuesLoadMore, onSubmit: handleAddValuesToSelectedNode, onClose: onClose, onValueSearch: handleValueSearch }));
};
exports.AddValueContainer = AddValueContainer;
exports.default = exports.AddValueContainer;
